import React from 'react';
import PropTypes from 'prop-types';
import css from './InterventionIcon.css';
import Icon from 'SF/MaterialIcon';
import { isEmptyString } from 'utils/text';
import classnames from 'classnames';
import { omit } from 'lodash';

export default class InterventionIcon extends React.PureComponent {

  get icon() {
    if (!this.props.category) return '';
    switch (this.props.category.toLowerCase()) {
      case "flag":
        return  'flag';
      case "referral":
        return  'exit_to_app';
      case "kudos":
        return 'star';
      case "to-do":
        return 'check_box';
      default:
        return '';
    }
  }

  render() {
    const categories = ['flag', 'referral', 'kudos', 'to-do'];
    const label = categories.includes(this.props.category) ? "Feedback provided for " + this.props.category : "";
    return <Icon icon={this.icon} 
                 aria-label={label} 
                 className={classnames(css['intervention-icon'], {[this.props.className]: !isEmptyString(this.props.className)})}
                 {...omit(this.props, ['category', 'className', 'name'])}
    />
  }
}

InterventionIcon.propTypes = {
  category: PropTypes.string,
  className: PropTypes.string
};
